<template>
  <b-row>
    <b-col cols="12" class="container min-vh-100">
      <b-row>
        <b-card class="w-100 h-100">
          <ValidationObserver ref="form">
            <b-row>
              <b-col cols="12">
                <h3 class="mt-3 mb-3">ผู้ถูกตรวจสอบ</h3>
              </b-col>

              <ValidationProvider
                name="ผู้ถูกตรวจสอบ"
                rules="required"
                v-slot="{ errors }"
                class="w-100"
              >
                <b-col class="container text-right mt-n2">
                  <b-button
                    variant="primary"
                    @click="
                      onBtnCompanySearchClicked({
                        compId: '',
                        companyDetail: '',
                        address: null,
                      })
                    "
                  >
                    <feather-icon icon="PlusIcon" class="mr-25" />
                    <span>ค้นหาผู้ประกอบธุรกิจ</span>
                  </b-button>
                </b-col>
                <b-col cols="12">
                  <b-list-group flush>
                    <span class="text-danger ml-2 ">{{ errors[0] }}</span>
                    <b-list-group-item>
                      <input v-model="company" type="hidden" />
                      <CompanySearch
                        v-if="company !== null && company !== undefined"
                        :company="company"
                        :IsEdit_CompanySearch="true"
                        :IsProvince_CompanySearch="false"
                        @handle-edit="onBtnCompanySearchClicked"
                        @handle-delete="onBtnCompanySearchDeleteClicked"
                      />
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </ValidationProvider>

              <b-col cols="6" class="">
                <b-form-group>
                  <label for="consultSubject"
                    >วันที่ดำเนินการ <span class="text-danger">*</span></label
                  >
                  <ValidationProvider
                    rules="required"
                    name="วันที่ดำเนินการ"
                    v-slot="{ errors }"
                  >
                    <b-form-datepicker
                      v-model="verifyDate"
                      v-bind="languages || {}"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      locale="th"
                      :hide-header="false"
                      today-button
                      reset-button
                      close-button
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-row
                v-for="(item, key) in verifyDetails"
                :key="key"
                class="col-12"
              >
                <b-col cols="12">
                  <hr class="my-12" />
                </b-col>
                <b-col class="container text-right mt-2">
                  <b-button
                    v-if="verifyDetails.length > 1"
                    variant="danger"
                    @click="onBtnRemoveVerifyDetailClicked(key)"
                  >
                    <feather-icon icon="MinusIcon" class="mr-25" />
                    <span>ลบ</span>
                  </b-button>
                </b-col>
                <ValidationProvider
                  rules="required"
                  name="ประเภทการตรวจสอบ"
                  v-slot="{ errors }"
                  class="col-12"
                >
                  <b-form-group>
                    <label for="compName"
                      >ประเภทการตรวจสอบ <span class="text-danger">*</span
                      ><span class="text-danger">{{ errors[0] }}</span></label
                    >

                    <div class="row">
                      <b-col
                        v-for="rad in verifyDeps"
                        :key="rad.verifyDepId"
                        cols="12"
                        md="4"
                        class="mt-1 pl-2"
                      >
                        <b-form-radio
                          v-model="item.verifyDepId"
                          :value="rad.verifyDepId"
                          @change="onVerifyDepChange(rad.verifyDepId, item)"
                        >
                          {{ rad.description }}
                        </b-form-radio>
                      </b-col>
                    </div>
                  </b-form-group>
                </ValidationProvider>

                <ValidationProvider
                  rules="required"
                  name="ประกาศ/คำสั่ง/กฏกระทรวง/ระเบียบ"
                  v-slot="{ errors }"
                  class="col-12"
                >
                  <b-form-group>
                    <label for="compName"
                      >ประกาศ/คำสั่ง/กฏกระทรวง/ระเบียบ
                      <span class="text-danger">*</span
                      ><span class="text-danger">{{ errors[0] }}</span></label
                    >

                    <div class="row">
                      <b-col
                        v-for="rad in item.verifyMinistries"
                        :key="rad.varifyMinistryId"
                        cols="12"
                        class="mt-1 pl-2"
                      >
                        <b-form-radio
                          v-model="item.varifyMinistryId"
                          :value="rad.varifyMinistryId"
                        >
                          {{ rad.description }}
                        </b-form-radio>
                      </b-col>
                    </div>
                  </b-form-group>
                </ValidationProvider>

                <ValidationProvider
                  rules="required"
                  name="ผลการตรวจสอบ"
                  v-slot="{ errors }"
                  class="col-12"
                >
                  <b-form-group>
                    <label for="compName"
                      >ผลการตรวจสอบ <span class="text-danger">*</span
                      ><span class="text-danger">{{ errors[0] }}</span></label
                    >

                    <div class="row">
                      <b-col
                        v-for="rad in verifyStatuses"
                        :key="rad.verifyStatusId"
                        cols="12"
                        md="4"
                        class="mt-1 pl-2"
                      >
                        <b-form-radio
                          v-model="item.verifyStatusId"
                          :value="rad.verifyStatusId"
                        >
                          {{ rad.description }}
                        </b-form-radio>
                      </b-col>
                    </div>
                  </b-form-group>
                </ValidationProvider>

                <b-col cols="12" class="">
                  <b-form-group>
                    <label for="remark">ผลการตรวจสอบ</label>
                    <ValidationProvider name="ผลการตรวจสอบ" v-slot="{ errors }">
                      <b-form-textarea
                        v-model="item.resultDescription"
                        rows="5"
                      ></b-form-textarea>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <p>เอกสารแนบ</p>
                </b-col>

                <b-row
                  v-for="file in item.attachFiles"
                  :key="file.attachId"
                  class="col-12 m-1 col-md-6"
                >
                  <b-col md="10">
                    <a
                      :href="file.filePath"
                      :download="file.fileName"
                      target="_blank"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-arrow-down-circle"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="8 12 12 16 16 12" />
                        <line x1="12" y1="8" x2="12" y2="16" />
                      </svg>
                      {{ file.fileName }}
                    </a>
                  </b-col>
                  <b-col md="2" class="d-flex justify-content-center">
                    <a
                      href="javascript:void(0)"
                      class="text-danger"
                      @click="onAttachFileDelete(file.attachId, item)"
                    >
                      <feather-icon icon="Trash2Icon" size="24" />
                    </a>
                  </b-col>
                </b-row>
                <b-col cols="12" md="6">
                  <b-form-group>
                    <b-form-file
                      @change="
                        onUploadFileChanged($event, item, 'file-input' + key)
                      "
                      :ref="'file-input' + key"
                      multiple
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                    />
                  </b-form-group>
                </b-col>

                <ValidationProvider
                  rules="required"
                  name="ผลการดำเนินการ"
                  v-slot="{ errors }"
                  class="col-12"
                >
                  <b-form-group>
                    <label for="compName"
                      >ผลการดำเนินการ <span class="text-danger">*</span
                      ><span class="text-danger">{{ errors[0] }}</span></label
                    >

                    <div class="row">
                      <b-col
                        v-for="rad in verifyFlags"
                        :key="rad.verifyFlag"
                        cols="12"
                        md="4"
                        class="mt-1 pl-2"
                      >
                        <b-form-radio
                          v-model="item.verifyFlag"
                          :value="rad.verifyFlag"
                        >
                          {{ rad.description }}
                        </b-form-radio>
                      </b-col>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-row>

              <b-col
                v-if="currentQueryId === null"
                class="container text-right mt-2"
              >
                <b-button
                  variant="primary"
                  @click="onBtnAddVerifyDetailClicked"
                >
                  <feather-icon icon="PlusIcon" class="mr-25" />
                  <span>เพิ่มรายการตรวจสอบ</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr class="my-12" />
              </b-col>

              
              <b-col cols="6" class="">
                <b-col v-if="isProvincialOfficer() === true"> 
                  <b-form-group>
                    <label>จังหวัด</label>
                    <input v-model="currentUserProvinceName.text" type="text" class="form-control" :disabled="true" />
                  </b-form-group>
                </b-col>
                <b-col v-else>
                  <b-form-group>
                    <label>กองเจ้าหน้าที่</label>
                    <input v-model="currentDepartmentName.text" type="text" class="form-control" :disabled="true" />
                  </b-form-group>
                </b-col>
              </b-col>

              <!-- เจ้าหน้าที่ ภูมิภาค/จังหวัด -->
              <!-- <b-col v-if="isProvincialOfficer() === true" cols="6" class=""> 
                <b-form-group>
                  <label>จังหวัด</label>
                  <input v-model="currentUserProvinceName.text" type="text" class="form-control" :disabled="true" />
                </b-form-group>
              </b-col> -->

              <!-- เจ้าหน้าที่ กอง-->
              <!-- <b-col v-if="isProvincialOfficer() === false" cols="6" class="">
                <b-form-group>
                    <label>กองเจ้าหน้าที่</label>
                    <input v-model="currentUserDivision.divisionName" type="text" class="form-control" :disabled="true" />
                  </b-form-group>
              </b-col> -->

              <!-- เจ้าหน้าที่ กอง -->
              <!-- <b-col v-if="isProvincialOfficer() === false" cols="6" class="">
                <ValidationProvider
                  name="จังหวัด"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-group>

                    <label for="remark">
                      จังหวัด<span class="text-danger">*</span>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </label>

                    <input v-model="provinceCode" type="hidden" />

                    <vue-select
                      label="text"
                      v-model="provinceCode"
                      :options="provinces"
                      class="mt-1"
                    />
                  </b-form-group>
                  <b-form-group>
                    <label>กองเจ้าหน้าที่</label>
                    <input v-model="currentUserDivision.divisionName" type="text" class="form-control" :disabled="true" />
                  </b-form-group>
                </ValidationProvider>
              </b-col> -->

              <b-col cols="12" class="d-flex justify-content-between">
                <b-button variant="secondary" @click="onCancelBtnClicked">
                  ยกเลิก
                </b-button>
                <b-button variant="primary" @click="onSubmitBtnClicked">
                  บันทึกข้อมูล
                </b-button>
              </b-col>
            </b-row>
          </ValidationObserver>
        </b-card>
      </b-row>
    </b-col>

    <ModalCompany
      ref="modalCompanyComponent"
      :company="currentCompanyModal"
      @handle-submit="onBtnCompanySearchSubmit"
    />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BFormCheckbox,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTimepicker,
  BListGroupItem,
  BFormFile,
  BListGroup,
} from "bootstrap-vue";

import VueSelect from "vue-select";

import CompanyAddress from "../components/CompanyAddress.vue";
import CompanySearch from "../components/CompanySearch.vue";

import * as userStore from "@/store/api/user/index.js";
import * as companyStore from "@/store/api/company/index.js";
import * as storeMaster from "@/store/api/master/index.js";
import * as consultStore from "@/store/api/consult/index.js";
import * as complaintStore from "@/store/api/complaint/complaint.js";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import * as lang from "vuejs-datepicker/src/locale";

import * as verifyStore from "@/store/api/verify/index.js";
import ModalCompany from "../components/ModalCompany.vue";

import appsettings from "@/store/app-settings";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});
export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BFormCheckbox,
    BFormRadioGroup,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    BListGroup,
    BListGroupItem,
    ValidationObserver,
    ValidationProvider,
    extend,
    VueSelect,
    CompanyAddress,
    ModalCompany,
    CompanySearch,
  },
  data() {
    return {
      verifyDetails: [{}],
      company: null,
      verifyDate: null,
      attachTypes: [{ value: null, text: "ประเภทเอกสาร", disabled: true }],
      currentUserIdModal: "",
      languages: lang.th,
      verifyDeps: [],
      verifyStatuses: [],
      verifyFlags: [],
      provinces: [],
      currentCompIdModal: "",
      currentCompanyModal: {},
      selected: 22,
      provinceCode: null,
      currentQueryId: null,
      currentUserDivision: {},
      currentUserProvinceName: "",
      currentDepartmentName: {},
      department: {
        value: userData.selectedAdminDepartment(),
        text: "",
      },
    };
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
      this.getProvinces();
    } else {
      const id = this.$route.query.id;
      this.currentQueryId = id;
      this.getVerifyDetail(id);
    }
    this.getVerifyDeps();
    this.getVerifyStatuses();
    this.getVerifyFlags();
    this.getDepartmentName();

    extend("checkRequired", {
      validate(value) {
        return {
          required: true,
          valid: _this.tab3check(),
        };
      },
      message: "กรุณาเลือก{_field_} อย่างน้อย 1 หมวดหมู่",
      computesRequired: true,
    });
  },
  methods: {
    isProvincialOfficer() {
      const _this = this;
      if ('25e8af7c-d072-47fd-985b-fb1eefc44764' === userData.selectedRole()) {
        return true;
      }

      return false;
    },
    onVerifyDepChange(verifyDepId, verifyDetail) {
      const _this = this;

      verifyStore.getVerifyMinistries(verifyDepId).then((response) => {
        if (response.data.success === true) {
          verifyDetail.verifyMinistries = response.data.data;
          //console.log("verifyDetail", verifyDetail);
          if (verifyDetail.varifyMinistryId != null) {
            let verifyMinis = verifyDetail.verifyMinistries.find((value) => {
              return value.varifyMinistryId === verifyDetail.varifyMinistryId;
            });

            console.log("verifyMinis", verifyMinis);

            if (verifyMinis === null || verifyMinis === undefined) {
              verifyDetail.varifyMinistryId = null;
            }
          }
          _this.$forceUpdate();
        }
      });
    },
    onBtnCompanySearchClicked(companyObj) {
      this.currentCompanyModal = companyObj;
      this.$refs.modalCompanyComponent.$refs["modal-company"].show();
    },
    onBtnCompanySearchDeleteClicked() {
      this.company = null;
    },
    onBtnCompanySearchSubmit() {
      this.$refs.modalCompanyComponent.$refs["modal-company"].hide();
      console.log("currentCompanyModal", this.currentCompanyModal);
      this.company = this.currentCompanyModal;
    },
    onBtnAddVerifyDetailClicked() {
      this.verifyDetails.push({});
    },
    onBtnRemoveVerifyDetailClicked(key) {
      console.log("key is", key);

      const filteredArray = this.verifyDetails.splice(key, 1);

      //this.verifyDetails = filteredArray;
    },
    getVerifyDeps() {
      const _this = this;

      verifyStore
        .getVerifyDeps()
        .then((response) => {
          if (response.data.success) {
            _this.verifyDeps = response.data.data;
          }
          // console.log("getVerifyDeps", response.data.data);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getVerifyStatuses() {
      const _this = this;

      verifyStore
        .getVerifyStatuses()
        .then((response) => {
          if (response.data.success) {
            _this.verifyStatuses = response.data.data;
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getVerifyFlags() {
      const _this = this;

      verifyStore
        .getVerifyFlags()
        .then((response) => {
          if (response.data.success) {
            _this.verifyFlags = response.data.data;
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getProvinces(provinceCodeValue = null) {
      const _this = this;
      storeMaster
        .getProvince()
        .then(function(response) {

          _this.provinces = response.data.data;

          // ดึงชื่อของจังหวัดปัจจุบันของเจ้าที่ ภูมิภาค/จังหวัด เท่านั้น
          _this.currentUserProvinceName = _this.provinces.find(o => o.value === userData.province());
          // _this.currentUserProvinceName = _this.provinces.find(o => o.value === userData.tempProvince());

          if (provinceCodeValue !== null) {
            let provinceSelected = _this.provinces.find((province) => {
              return province.value == provinceCodeValue;
            });
            console.log("ทดสอบ provinceSelected", provinceSelected);
            _this.provinceCode = provinceSelected;
          }
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getVerifyDetail(id) {

      console.log("ทดสอบ 1", id)

      const _this = this;

      verifyStore
        .getById(id)
        .then((response) => {
          if (response.data.success === true) {

            console.log("ทดสอบ 2", [response.data.data]);

            _this.verifyDetails = [response.data.data];

            _this.onVerifyDepChange(
              _this.verifyDetails[0].verifyDepId,
              _this.verifyDetails[0]
            );
            _this.getProvinces(_this.verifyDetails[0].provinceOfficeId);
            _this.verifyDate = _this.verifyDetails[0].varifyDate;
            _this.currentCompanyModal = _this.verifyDetails[0].compModel;
            _this.company = _this.currentCompanyModal;

            //console.log('_this.verifyDetails', _this.verifyDetails)
          } else {
            _this.$bvToast.toast("เกิดข้อผิดพลาด", {
              title: `เกิดข้อผิดพลาด`,
              variant: "danger",
              solid: false,
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            let verifyDatas = [];

            let provinceCodeData = null;

            if (_this.isProvincialOfficer()) {
              provinceCodeData = parseInt(userData.province());
            } else {
              // provinceCodeData = parseInt(_this.provinceCode.value);
            }

            // console.log("provinceCodedata", provinceCodeData);

            _this.verifyDetails.forEach((value) => {
              let vData = value;
              vData.varifyDate = _this.verifyDate;
              vData.compId = _this.company.compId;
              vData.provinceOfficeId = provinceCodeData;
              vData.departmentId = userData.departmentId();
              verifyDatas.push(vData);
            });

            console.log("verifyDatas", verifyDatas, _this.provinceCode);
            
            
            const params = {
              data: verifyDatas,
            };
            verifyStore
              .updateItem(params)
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });
                  window.open(
                    _this.$router.resolve({
                      name: "Verify",
                    }).href,
                    "_self"
                  );
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              });
          }
        });
      });
    },
    onCancelBtnClicked() {
      window.open(this.$router.resolve({ name: "Verify" }).href, "_self");
    },
    onUploadFileChanged(e, verifyDetail, refKey) {
      const selectedFiles = e.target.files;
      if (selectedFiles === null || selectedFiles === undefined || selectedFiles.length <= 0) {
        return;
      }

      const _this = this;
      var isMissing = this.onValidateExtensionFiles(selectedFiles, null, refKey);
      if (isMissing === true) {
        return;
      }

      selectedFiles.forEach(function(value, index) {
        _this.createBase64Image(value, verifyDetail, refKey);
      });
    },
    createBase64Image(fileObject, verifyDetail, refKey) {
      const _this = this;
      const reader = new FileReader();

      const fileName = fileObject.name;
      const fileSize = fileObject.size;

      reader.onload = (e) => {
        const fileBase64 = e.target.result;
        console.log("refKey", refKey, _this.$refs[refKey], _this.$refs);
        _this.$refs[refKey][0].reset();

        const data = [
          {
            fileName: fileName,
            fileSize: fileSize,
            fileBase64: fileBase64,
            fileType: _this.selected,
            masterId: _this.selected,
          },
        ];
        storeFileUpload
          .uploadFile(data)
          .then(function(response) {
            // handle success
            // console.log(response);
            response.data.data.forEach(function(value, index) {
              _this.emitUploadFile(value, verifyDetail);
            });
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          })
          .then(function() {
            // always executed
          });
        //console.log('base64', base64)
      };

      reader.readAsDataURL(fileObject);
    },
    emitUploadFile(file, verifyDetail) {
      if (
        verifyDetail.attachFiles === null ||
        verifyDetail.attachFiles === undefined
      )
        verifyDetail.attachFiles = [];

      verifyDetail.attachFiles.push(file);

      this.$forceUpdate();
    },
    onAttachFileDelete(id, verifyDetail) {
      console.log("file id=", id, "attchFiles=", verifyDetail.attachFiles);
      const file = verifyDetail.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = verifyDetail.attachFiles.filter(
        (o) => o.attachId != id
      );

      verifyDetail.attachFiles = filteredAry;

      this.$forceUpdate();
    },
    getDepartmentName() { // ดึง department name ทั้งหมด
      const _this = this;

      storeMaster
        .getDepartment(2)
        .then(function(response) {
          // handle success
          console.log("response", response);

          _this.currentDepartmentName = response.data.data.find((value) => {
            return value.value === _this.department.value;
          });
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });

    },
    onValidateExtensionFiles(selectedFiles, section, refKey) {
      console.log(`onvalidateextensionfiles.section`, section);
      let isMissing = false;

      // เช็คว่าไฟล์ที่อัพโหลดมีสกุลไฟล์หรือไม่
      // ถ้าไม่มีให้แสดง popup แจ้งเตือน
      const arrNoExtension = Object.values(selectedFiles).filter((file) => {
        return (
          file.type === null || file.type === undefined || file.type === ""
        );
      });

      if (arrNoExtension.length > 0) {
        isMissing = true;
        this.$swal({
          html:
            "<div>ไม่สามารถอัพโหลดไฟล์ที่ไม่มีสกุลไฟล์ได้<br />กรุณาตรวจสอบไฟล์ของท่านก่อนทำการอัพโหลด</div>",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        }).then((result) => {
          try {
            this.$refs[refKey][0].reset();
          } catch (ex) {
            console.log(ex);
          }
        });
      }

      return isMissing;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>
